import { useEffect, useRef, useState } from 'react';
import RoundedButtonSecondary from '../rounded-button-secondary/RoundedButtonSecondary';
import styles from './copy-text-button.module.less';
import { TextArea } from '@sb1/ffe-form-react';

const CopyTextButton = ({
    text = '',
    label,
    trackingFunction,
    className = '',
    readonly = true,
    children,
    rows = 4,
}) => {
    const [copied, setCopied] = useState(false);
    const [input, setInput] = useState(text);
    const textElement = useRef(null);

    useEffect(() => {
        setInput(text);
    }, [text]);

    const copyUrl = (e) => {
        textElement.current.select();
        document.execCommand('copy');
        e.target.focus();
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 3000);
    };

    return (
        <div className={styles.shareLink}>
            <TextArea
                title={label}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                className={[styles.shareLinkInput, className].join(' ')}
                ref={(current) => {
                    textElement.current = current;
                }}
                rows={rows}
                readOnly={readonly}
            />
            <div className={styles.buttonsWrapper}>
                <div className={styles.buttons}>
                    <RoundedButtonSecondary
                        onClick={(e) => {
                            copyUrl(e);
                            trackingFunction && trackingFunction();
                        }}
                    >
                        <i className="fa-solid fa-copy" aria-hidden="true" /> Kopier tekst
                    </RoundedButtonSecondary>
                    {children}
                </div>
                <div
                    className={copied ? styles.shareLinkCopied : styles.shareLinkCopiedHidden}
                    aria-hidden={copied ? '' : true}
                >
                    Kopiert!
                </div>
            </div>
        </div>
    );
};

export default CopyTextButton;
